var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTestTubePlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.0009 1L19.001 2L18.0011 3L18.0009 5L16.001 5.00003V3H8.00092V5.00003L6.00098 5V11.9999L7.00096 10.9999H11.0009V7.00002L12.0009 6.00003L13.0009 7.00002V10.9999H17.001L18.0009 11.9999L17.001 12.9999H13.0009V17L12.0009 18.0001L11.0009 17V12.9999H7.00096L6.00098 11.9999V19H8.00092C8.00092 20.1046 8.89636 20.9999 10.0009 20.9999H14.0009C15.1055 20.9999 16.001 20.1046 16.001 19H18.0009C18.0009 21.2092 16.2101 23 14.0009 23H10.0009C7.79179 23 6.00098 21.2092 6.00098 19L6.00092 2.99994L5.00098 2L6.00092 1.00006L18.0009 1Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTestTubePlus);
export default __webpack_public_path__ + "static/media/test-tube-plus.f30ed9ab88b69fb3611cf31eab9b83e0.svg";
export { ForwardRef as ReactComponent };